import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Switch } from "antd";
import {
  togglePressEnterToSendMessage,
  toggleDynamicMessageFilter,
  toggleAlwaysOpenNewMessages,
  toggleReceiveEmailNotifications,
} from "../../store/actions/general-settings";
import UserService from "../../services/user";
import "./GeneralSettings.scss";

class GeneralSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.toggleDynamicMessageFilter =
      this.toggleDynamicMessageFilter.bind(this);
    this.toggleAlwaysOpenNewMessages =
      this.toggleAlwaysOpenNewMessages.bind(this);
    this.togglePressEnterToSendMessage =
      this.togglePressEnterToSendMessage.bind(this);
    this.toggleReceiveEmailNotifications =
      this.toggleReceiveEmailNotifications.bind(this);
  }

  toggleDynamicMessageFilter() {
    this.props.toggleDynamicMessageFilter();
    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: !this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: this.props.options.alwaysOpenNewMessages,
      emailNotification: this.props.options.receiveEmailNotifications,
      pressEnterToSendMessages: this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });
  }

  toggleAlwaysOpenNewMessages() {
    this.props.toggleAlwaysOpenNewMessages();
    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: !this.props.options.alwaysOpenNewMessages,
      emailNotification: this.props.options.receiveEmailNotifications,
      pressEnterToSendMessages: this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });
  }

  togglePressEnterToSendMessage() {
    this.props.togglePressEnterToSendMessage();
    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: this.props.options.alwaysOpenNewMessages,
      emailNotification: this.props.options.receiveEmailNotifications,
      pressEnterToSendMessages: !this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });
  }

  toggleReceiveEmailNotifications() {
    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: this.props.options.alwaysOpenNewMessages,
      emailNotification: !this.props.options.receiveEmailNotifications,
      pressEnterToSendMessages: this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });
    this.props.toggleReceiveEmailNotifications();
  }

  render() {
    const {
      dynamicMessageFilter,
      alwaysOpenNewMessages,
      pressEnterToSendMessage,
      receiveEmailNotifications,
    } = this.props.options;

    return (
      <div className="general-settings">
        <span className="general-settings-section">
          <FormattedMessage id="settings.inbox" />
        </span>
        <div className="general-settings-option-container">
          <span className="general-settings-option">
            <FormattedMessage id="settings.dynamicMessage" />
            <Switch
              defaultChecked={dynamicMessageFilter}
              onChange={this.toggleDynamicMessageFilter}
            />
          </span>
          <span className="general-settings-option-description">
            <FormattedMessage id="settings.dynamicMessage.description" />
          </span>
          <span className="general-settings-option">
            <FormattedMessage id="settings.alwaysOpenNewMessages" />
            <Switch
              defaultChecked={alwaysOpenNewMessages}
              onChange={this.toggleAlwaysOpenNewMessages}
            />
          </span>
          <span className="general-settings-option-description">
            <FormattedMessage id="settings.alwaysOpenNewMessages.description" />
          </span>
        </div>

        <span className="general-settings-section">
          <FormattedMessage id="settings.sendMessage" />
        </span>
        <div className="general-settings-option-container">
          <span className="general-settings-option">
            <FormattedMessage id="settings.pressEnterToSendMessage" />
            <Switch
              defaultChecked={pressEnterToSendMessage}
              onChange={this.togglePressEnterToSendMessage}
            />
          </span>
          <span className="general-settings-option-description">
            <FormattedMessage id="settings.pressEnterToSendMessage.description" />
          </span>
        </div>

        <span className="general-settings-section">
          <FormattedMessage id="settings.notifications" />
        </span>
        <div className="general-settings-option-container">
          <span className="general-settings-option">
            <FormattedMessage id="settings.receiveEmailNotifications" />
            <Switch
              defaultChecked={receiveEmailNotifications}
              onChange={this.toggleReceiveEmailNotifications}
            />
          </span>
          <span className="general-settings-option-description">
            <FormattedMessage id="settings.receiveEmailNotifications.description" />
          </span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    options: state.GeneralSettings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleDynamicMessageFilter: (status) =>
    dispatch(toggleDynamicMessageFilter()),
  toggleAlwaysOpenNewMessages: (status) =>
    dispatch(toggleAlwaysOpenNewMessages()),
  togglePressEnterToSendMessage: (status) =>
    dispatch(togglePressEnterToSendMessage()),
  toggleReceiveEmailNotifications: (status) =>
    dispatch(toggleReceiveEmailNotifications()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GeneralSettings);
